import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

// COMPONENTS
import Layout from "../components/layout";
import Seo from "../components/Seo";

const ServicesPage = ({ data }) => {
  // const servicesPageData = data.allMarkdownRemark.edges;

  return (
    <Layout>
      <Seo title="Services - N.Johnstone&Co " />
      <div className="services-page">
        <div className="services-hero">
          <div className="services-hero-content">
            <h1>Services</h1>
            <p>We offer a range of services that can help keep your business organized so you don't have to.</p>
          </div>
        </div>
        <div className="container">
          <div className="service-list">
            <div className="row">
              <div className="service-option col sm12 md12 lg4">
                <StaticImage
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                    width: '250px',
                    height: '250px',
                    overflow: 'hidden',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                  styleImg={{
                    width: 'auto',
                    height: '100%',
                    marginLeft: '-50px'
                  }}
                  src="../images/calendar.webp"
                  alt="C-Suite Support" />
                <div className="service-content">
                  <h2>C-Suite Support</h2>
                  <p>
                    Most executives struggle with time management when it comes to calendars, email, expenses, invoicing, and travel coordination. These are the tactical day-to-day tasks that are removed from your plate as we act as a gate-keeper for all projects and meetings.</p>
                </div>
              </div>
              <div className="service-option col sm12 md12 lg4">
                <StaticImage
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                    width: '250px',
                    height: '250px',
                    overflow: 'hidden',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                  styleImg={{
                    width: 'auto',
                    height: '100%',
                    marginLeft: '-50px'
                  }}
                  src="../images/operations.webp"
                  alt="Operations" />
                <div className="service-content">
                  <h2>Operations</h2>
                  <p>
                    This includes implementing systems and processes outside of the day-to-day executive support such as; HR onboarding flow, the customer experience, sourcing and hiring candidates, company wide communications.</p>
                </div>
              </div>
              <div className="service-option col sm12 md12 lg4">
                <StaticImage
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                    width: '250px',
                    height: '250px',
                    overflow: 'hidden',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                  styleImg={{
                    width: 'auto',
                    height: '100%',
                    marginLeft: '-50px'
                  }}
                  src="../images/project.webp"
                  alt="Project Coordination" />
                <div className="service-content">
                  <h2>Project Coordination</h2>
                  <p>
                    Experienced in remote working project management using Excel, Asana, Trello, and Monday we're there to propel timelines and hit weekly, monthly and quarterly goals.</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="service-option col sm12 md12 lg4">
                <StaticImage
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                    width: '250px',
                    height: '250px',
                    overflow: 'hidden',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                  styleImg={{
                    width: 'auto',
                    height: '100%',
                    marginLeft: '-50px'
                  }}
                  src="../images/temp.webp"
                  alt="Temp Services" />
                <div className="service-content">
                  <h2>Temp Services</h2>
                  <p>
                    Providing temporary Executive Assistant, Admin and Operations services. This includes contract copywriting, part-time, short term roles that need to be covered. If you're in a pinch we offer same day arrangements.</p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </Layout>
  )
}

// export const servicesPageQuery = graphql`

// `

export default ServicesPage;